<template>
  <div class="art-item item3-add-list">
    <common-top :commonTopData="commonTopData"></common-top>
    <div class="page-title" v-text="pageTitle"></div>
    <div class="top-title">
      <el-form class="add-form" :model="addForm" :disabled="isDisabled" :label-width="labelWidth">
        <el-form-item label="专题列表名称" prop="title">
          <el-input v-model="addForm.title" placeholder="请输入" maxlength="20" clearable show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="专题列表描述" prop="desc">
          <el-input v-model="addForm.desc" placeholder="请输入" maxlength="100" type="textarea" clearable show-word-limit resize="none"></el-input>
        </el-form-item>
        <el-form-item label="标签" prop="title">
          <div class="tips">用于推荐、查询（请至少选择1个）</div>
          <el-select v-model="addForm.tags" multiple filterable allow-create default-first-option placeholder="请选择" ref="tagbox">
            <el-option-group
            class="aaa"
              v-for="group in tagList"
              :key="group.label"
              :label="group.label">
              <el-option
                v-for="item in group.tags"
                :key="item"
                :label="item"
                :value="item">
              </el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <el-form-item label="展示位样式模板">
          <el-button class="select-btn" size="small" @click="selectTmp">选择展示样式</el-button>
          <div class="preview-pic" v-if="addForm.tmpImg">
            <span class="tmp-name" v-text="addForm.tmpTitle"></span>
            <img class="tmp-pic" :src="addForm.tmpImg" alt="模板样式">
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div class="content">
      <div class="content-title">列表配置</div>
      <el-form class="add-form" :model="addForm" :disabled="isDisabled" :label-width="labelWidth">
        <el-form-item label="顶部专题图" prop="title">
          <w-upload-image
            style="overflow: hidden;"
            class="upload-img"
            :size="8"
            tipsText="建议尺寸：376*140；png/jpg"
            v-model="addForm.prev_url">
          </w-upload-image>
        </el-form-item>
      </el-form>
    </div>
    <div class="content content2">
      <el-form :disabled="isDisabled">
        <div class="content-title">列表关联内容</div>
        <el-radio-group class="art-radio-group" v-model="radio1" size="small">
          <el-radio-button label="全部内容"></el-radio-button>
          <el-radio-button label="上线内容"></el-radio-button>
        </el-radio-group>
        <div class="tips">待上架的内容仅会展示在体验版</div>
        <ul>
       
          <li>
            <div @click="sujFn" class="all-online2">随机排序</div>
            <div @click="allTy()" class="all-online2">{{isall?'全部下线':'全部上线'}}</div>
          </li>
          <commontz :list="showList" >
            <template  v-slot:default="{item,index}">
           
          
               <div class="item" v-if="radio1 =='全部内容' || item.status==1">
              <div class="left">
                <img :src="item.prev_url" alt="内容缩略图" />
              </div>
              <div class="right">
                <div class="title-box">
                  <span class="tit tit1">ID：<b v-text="item.id"></b></span>
                  <span class="tit tit1">标题：<b v-text="item.title"></b></span>
                  <span class="tit tit2">副标：<b v-text="item.sub_title"></b></span>
                  <span class="tit tit3">跳转：<b v-clipboard:copy="item.jump_to" v-clipboard:success="onCopy" v-text="item.jump_to"></b></span>

                  
                </div>
                <div>
                    <span class="tit tit3">上架状态：</span>
                    <span  @click="showDg(item)">
                      <span class="btn_xtx_01">{{backTypeshow(item)}}</span>
                      <div v-if="item.start_time">{{`${item.start_time}——${item.end_time}`}}</div>
                    </span>
                    
            
                </div>
              </div>
            </div>
            <div class="handle">
              <span class="handle-btn" @click="handleFn2(showList,index)">置顶</span>
              <span class="handle-btn" @click="handleFn(lists, index, index-1)">上移</span>
              <span class="handle-btn" @click="handleFn(lists, index, index+1)">下移</span>
              <span class="handle-btn" @click="delFn(index)">删除</span> 

              <span class="handle-btn" @click="editFn(item.id)">编辑</span> 
              
            </div>
            </template>
        </commontz>
         
        

        
          <!-- <li draggable="true" 
          @dragenter="dragenterf($event,index)"
          @dragover="dragoverf($event)"
          @dragstart="dragstartf(index)"
          
          v-for="(item, index) in showList" :key="index">
            <div class="item">
              <div class="left">
                <img :src="item.prev_url" alt="内容缩略图" />
              </div>
              <div class="right">
                <div class="title-box">
                  <span class="tit tit1">标题：<b v-text="item.title"></b></span>
                  <span class="tit tit2">副标：<b v-text="item.sub_title"></b></span>
                  <span class="tit tit3">跳转：<b v-text="item.jump_to"></b></span>
                </div>
                <div>
                    <span class="tit tit3">上架状态：</span>
                    <span  @click="showDg(item)">
                      <span class="btn_xtx_01">{{backTypeshow(item)}}</span>
                      <div v-if="item.start_time">{{`${item.start_time}——${item.end_time}`}}</div>
                    </span>
                    
            
                </div>
              </div>
            </div>
            <div class="handle">
              <span class="handle-btn" @click="handleFn2(showList,index)">置顶</span>
              <span class="handle-btn" @click="handleFn(lists, index, index-1)">上移</span>
              <span class="handle-btn" @click="handleFn(lists, index, index+1)">下移</span>
              <span class="handle-btn" @click="delFn(index)">删除</span>
            </div>
          </li> -->
        </ul>
        <div class="select-btn">
          <el-button size="small" @click="selectFn" >选择关联内容</el-button>
        </div>
      </el-form>
    </div>
    <div class="foot-btn">
      <el-button size="small" @click="backFn">返回</el-button>
      <el-button size="small" type="primary" @click="createFn" :disabled="isDisabled">创建</el-button>
    </div>

    <!--专题列表样式-->
		<el-dialog class="item3-add-pop" title="请选择专题列表展示样式" :visible.sync="tmpVisible" :before-close="handleClose">
      <ul>
        <li v-for="(item, index) in tmpList" :key="item.id" :class="active === index ? 'on' : ''" @click="activeFn(index)">
          <span class="title" v-text="item.title"></span>
          <img :src="item.img" alt="列表样式">
        </li>
      </ul>
			<div slot="footer" class="dialog-footer">
				<el-button @click="tmpVisible = false">关闭</el-button>
				<el-button type="primary" @click="confirmFn">提交</el-button>
			</div>
		</el-dialog>

    <component @sucss="savePopFn" :listids="listids" :config="tnconfig" @close="close" v-bind:is="componentName"></component>

      <el-dialog
      title="上线设置"
      class="item3-add-pop"
      :visible.sync="sxdg"
      width="30%"
      :before-close="handleClose"
    >
      <el-radio-group class="art-radio-group" v-model="forMdat.type" size="small">
        <el-radio-button label="0">
          <span>待上架</span>
        </el-radio-button>
        <el-radio-button label="1">
          <span>永久上架</span>
        </el-radio-button>
        <el-radio-button label="2">
          <span>上架时间段</span>
        </el-radio-button>
        <el-radio-button label="-1">
          <span>下架</span>
        </el-radio-button>
      </el-radio-group>
      <el-date-picker
        v-show="forMdat.type == 2"
        v-model="forMdat.times"
        type="datetimerange"
        value-format="yyyy-MM-dd HH:mm:ss"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        placeholder="请选择上线时间段；超过时间段将自动下线"
      >
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="sxdg = false">关 闭</el-button>
        <el-button size="small" type="primary" @click="onlineConfirm()"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import commonTop from "@/components/commonTop.vue";
import addWz from "./addWz.vue";
import commontz from "@/components/tz.vue";
export default {
  components: {
    commonTop,
    addWz,
    commontz
  },
  computed:{
    showList(){
      // if(this.radio1=='上线内容'){
      //   return this.lists.filter(e=>{
      //     return e.status=='1';
      //   })
      // }
      return this.lists
    },
		isall(){			
			return this.showList.length>0 && !this.showList.find(e=>e.type==0 || e.status==0);
		}
	},
  data() {
    // 这里存放数据
    return {
      tnconfig:{},
      sxdg:false,
      showData:{},
      forMdat:{},
      componentName:'',
       jump_type:{
				'1':'专题列表',
				'2':'大图',
				'3':'视频',
				'4':'文章',
				'5':'链接'
			},
      pageTitle: '新建专题列表',
      id: this.$route.query.id,
      type: this.$route.query.type,
      labelWidth: '110px',
      drawer: false,
      isDisabled: false, // 是否禁用
			dialogVisible: false,
      commonTopData: {
        commonleftbtn: [],
      },
      addForm: {
        title: '',
        desc: '',
        tags: [],
        prev_url: '',
        tmpTitle: '',
        tmpImg: ''
      },
      tagList: [],
      active: 0,
      radio1: "全部内容",
      tmpVisible: false, // 专题列表是否显示
      lists: [],
      listids:[],
      tmpList: [
        { img: 'http://static.zookingsoft.com/shiquaner-admin/pc/s4.png', title: '左右切换列表' },
        { img: 'http://static.zookingsoft.com/shiquaner-admin/pc/s1.png', title: '三个一行列表' },
        { img: 'http://static.zookingsoft.com/shiquaner-admin/pc/s2.png', title: '单行内容列表' },
        { img: 'http://static.zookingsoft.com/shiquaner-admin/pc/s3.png', title: '上下切换列表' },
        { img: 'http://static.zookingsoft.com/shiquaner-admin/pc/s5.png', title: '左右切换列表(红色)' }
      ],
      item: '',
			form: {
        id: '',
        title: '',
        author: '',
        tags: ''
      },
      filterForm1: [
				{prop: 'id', label: '内容ID', pl: '请输入内容ID检索'},
				{prop: 'title', label: '内容标题', pl: '请输入文章标题检索'},
				{prop: 'author', label: '创作者昵称', pl: '请输入创作者检索'},
				{prop: 'tags', label: '标签', pl: '请输入标签检索'}
			],
      selectedData: [], // 已选择项目
      tableData: [],
      total: '',
      typeMap:{
        '-1':'下架',
        '0':'待上架',
        '1':'上架',
        '2':'待上架'//临时上架
      },
      statusMap:{
        '-1':'下架',
        '0':'待上架',
        '1':'上架'
      },
      dragIndex:0,
      oldtags:[],
    }
  },
  watch:{
    'forMdat.type'(){
      console.log(this.forMdat.type)
    }
  },
  mounted() {
    this.init()
    this.getSubjectTags()
  },
  // 方法集合
  methods: {
    onCopy(){
      this.$message('复制成功')
    },  
    init () {
      if (this.type === 'look') {
        this.pageTitle = '专题列表详情'
        this.isDisabled = true
        this.subjectDetail()
      }
      if (this.type === 'edit') {
        this.pageTitle = '编辑专题列表'
        this.isDisabled = false
        this.subjectDetail()
      }
    },
    backTypeshow(da){
      if(!da.type && da.status=='0' && da.start_time){
        da.type=2;
      }
      return this.typeMap[da.type] || this.statusMap[da.status]
    },
    showDg(obj){
      obj.type = obj.type || obj.status || '1';
      this.showData = obj;
      this.forMdat = Object.assign({},obj);
      this.sxdg = true;
    },
    onlineConfirm(){
      if(this.forMdat.type==2){
        if(!this.forMdat.times || !this.forMdat.times[0]){
          this.$message('请选择上架时间段')
          return
        }
        this.showData.start_time = this.forMdat.times[0];
        this.showData.end_time = this.forMdat.times[1];

      }else{
        this.showData.start_time = '';
        this.showData.end_time = '';
      }     
      this.showData.type = this.forMdat.type;     
      this.sxdg = false;
      this.showData = {};
      this.forMdat = {};
    },
    // 获取预设标签
    getSubjectTags () {
      let data = {
        config_name: 'subject_tags'
      }
      this.api.subjectTags(data).then(res => {
        if (!res) return

        let loc = localStorage.getItem('loctagList')
        if(loc){
          this.oldtags = JSON.parse(loc)
        }
        if(this.oldtags.length>0){
          res.data.config_value.unshift({
            label:'本地标签',
            tags:this.oldtags
          })
        }
        this.tagList = res.data.config_value;
      })
    },
    bclp2(da){
      return this.jump_type[da.jump_type] || ''
    },
    bclp(da){
      if(da.jump_type==2){
							return `<img class="tableImg" src="${da.jump_to}">`
						}
						if(da.jump_type==3){
							return `<video class="tableImg" src="${da.jump_to}"></video>`
						}
						return da.jump_to
    },
    sujFn(){
      this.lists.sort(function () {
          return Math.random() - 0.5;
      })
    },
    dragenterf(e,on){
      e.preventDefault();
      if(this.dragIndex !==on){
        const source = this.showList[this.dragIndex]
        this.showList.splice(this.dragIndex,1)
        this.showList.splice(on,0,source)
        this.dragIndex = on
      }

    },
    dragoverf(e){
      e.preventDefault();
    },
    dragstartf(on){
      this.dragIndex = on

    },
    allTy(){
			let str = '1';
			if(this.isall){
				str = '0';
			}
      
			this.lists = this.lists.map(e=>{
					e.type = str;
					return e
				})
			
		},
    handleFn2(arr,on){
      if(on==0){return}
      let po = this.lists[on];
      this.lists.splice(on,1);
      this.lists.unshift(po);

    },
    handleFn(arr, index1, index2) {
      if(index2 >= arr.length){
        this.$message.warning('到底了');
        return
      }
      if(index2 < 0){
        this.$message.warning('已经是第一个了');
        return
      }
      arr[index1] = arr.splice(index2, 1, arr[index1])[0]
      this.lists = arr
    },
    close(){
      this.componentName = '';
    },
    savePopFn (da) {
      let arr = da.map(e=>{
        e.type = '0';
        return e;
      })

      this.lists = this.lists.concat(arr)
			this.close();
		},
    // 专题详情
    subjectDetail () {
      let data = {
        id: this.id
      }
      this.api.subjectDetail(data).then(res => {
        if (!res) return

        this.addForm.title = res.title
        this.addForm.desc = res.desc
        try {
				this.addForm.tags = JSON.parse(res.tags)
        } catch (error) {
          this.addForm.tags = [];
        }
        //  1 方图列表样式  2 大图+小图列表样式  3 长图列表样式   4 横图列表样式
        this.addForm.tmpImg = this.tmpList[res.display_type - 1].img
        this.addForm.tmpTitle = this.tmpList[res.display_type - 1].title
        this.addForm.prev_url = res.prev_url
        this.active = +res.display_type - 1
        this.lists = res.content_info
      })
    },
		resetForm(formName) {
			this.$refs[formName].resetFields()
    },
		// 全选事件
    handleSelectionChange (val) {
      this.selectedData = val
    },
    lookBtn () {
      this.$message('look')
    },
    delFn (index) {
      this.lists.splice(index,1);
    },
    editFn(id){

      const { href } = this.$router.resolve({
        path: `/art/item3-addContent`,
        query: {
          id:id,
          type:'edit'
        }
      });
      window.open(href, "_blank");
    
    },
    selectFn() {
      this.componentName = 'addWz';
      this.tnconfig = {
        pr:{status:'0,1'}
      }

      this.listids = this.lists.map(e=>{
        return e.id
      })

      // this.dialogVisible = true
      // this.getPopData()
    },
    createFn() {
     
			let list = this.lists.map(item => {
        let obj = {
					id: item.id,
					type: item.type || item.status || '1'
				}
				if(item.type==2){
          obj.start_time = item.start_time;
          obj.end_time = item.end_time;
        }
        return obj
			})
      let data = {
        title: this.addForm.title,
        tags: JSON.stringify(this.addForm.tags),
        desc: this.addForm.desc,
        display_type: this.active + 1,
        prev_url: this.addForm.prev_url,
        relation_content: JSON.stringify(list)
      }
      if (!this.addForm.title) {
        this.$message.warning('专题列表名称不能为空')
        return
      }
      if (!this.addForm.desc) {
        this.$message.warning('专题列表描述不能为空')
        return
      }
      if (!this.addForm.tmpTitle) {
        this.$message.warning('展示位样式模板不能为空')
        return
      }
      if (!this.addForm.prev_url) {
        this.$message.warning('顶部专题图不能为空')
        return
      }
      if (this.lists.length == 0) {
        this.$message.warning('列表关联内容不能为空')
        return
      }

      /*存储本地tag*/
      let tag = JSON.parse(data.tags);
      let arrd = [];
      this.tagList.map(el=>{
        el.tags.map(el2=>{
          arrd.push(el2)
        })
      })
      
      tag.map(e=>{
        if(arrd.indexOf(e)==-1){
          this.oldtags.push(e)
        }
      })
      localStorage.setItem('loctagList',JSON.stringify(this.oldtags))


      if (this.type === 'add') {
        this.api.addSubject(data).then(res => {
          if (!res) return
          this.$message.success('创建成功')
          this.$router.push('/art/item3?tabs=comZt')
        })
      }
      if (this.type === 'edit') {
        data.id = this.id
        this.api.editSubject(data).then(res => {
          if (!res) return
          this.$message.success('编辑成功')
          this.$router.push('/art/item3?tabs=comZt')
        })
      }
    },
    backFn() {
      this.$router.push("/art/item3?tabs=comZt")
    },
    // 专题样式确定
    confirmFn () {
      this.addForm.tmpTitle = this.tmpList[this.active].title
      this.addForm.tmpImg = this.tmpList[this.active].img
      this.tmpVisible = false
    },
    // 筛选确定
    confirmDrawerFn () {
      this.getPopData(this.form)
    },
    getPopData (pr) {
			this.api.getContentList(pr || {}).then(res => {
				if (!res) return
				let { data, total } = res
				this.tableData = data
        this.total = total
			})
		},
    activeFn (index) {
      this.active = index
    },
    handleClose (done) {
      done()
      this.tmpVisible = false
    },
    selectTmp () {
      this.tmpVisible = true
    }
  },
};
</script>
<style lang='scss'>

.el-select-dropdown.is-multiple .el-select-dropdown__item.selected::after {
  color: #409eff !important;
}
.boxdop .el-dialog__footer{
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
}
.boxdop .el-dialog__body{
  padding-bottom: 70px !important;
}
.tableImg{
	display: inline-block;
	max-height: 80px;
	max-width:200px;
}
</style>

<style lang='scss' scoped>
.item3-add-list {
  height: 98vh;
  overflow: hidden;
  overflow-y: auto;
  background-color: #fff;
  .page-title {
    margin: 0 0 30px 30px;
    font-size: 16px;
  }
  .top-title {
    padding-left: 150px;
    .title-item {
      margin-bottom: 15px;
      .tit {
        margin-right: 10px;
      }
    }
    .add-form {
      .preview-pic {
        width: 16%;
        .tmp-pic {
          display: block;
          width: 100%;
          border-radius: 5px;
        }
      }
    }
  }
  .content {
    position: relative;
    margin-top: 30px;
    padding-left: 150px;
    border-top: 1px solid #e5e5e5;
    .art-radio-group {
      display: inline-block;
      margin: 0 20px;
    }
    .content-title {
      display: inline;
      position: relative;
      left: -120px;
    }
    .tips {
      display: inline;
      color: #828282;
    }
    .all-online {
      display: flex;
      justify-content: flex-end;
      width: 600px;
      margin: 10px 0;
      cursor: pointer;
      color: #33b3ff;
    }
    ul {
      li {
        display: flex;
        margin-bottom: 20px;
        .item {
          position: relative;
          display: flex;
          width: 600px;
          padding: 10px;
          word-break: break-all;
          border: 1px solid #999;
          border-radius: 4px;
          .left {
            img {
              width: 120px;
              height: 120px;
              border-radius: 4px;
              overflow: hidden;
            }
          }
          .right {
            flex: 1;
            margin-left: 15px;
            .title-box {
              min-height: 100px;
              .tit {
                display: block;
                margin-bottom: 6px;
              }
              b {
                font-weight: normal;
              }
            }
            .art-radio-group {
              position: absolute;
              right: 0;
              bottom: 6px;
              z-index: 9;
              color: #33b3ff;
            }
          }
        }
        .handle {
          margin-left: 10px;
          .handle-btn {
            margin-right: 20px;
            cursor: pointer;
          }
        }
      }
    }
  }
  .content2 {
    ul {
      margin-left: 100px;
    }
    .select-btn {
      margin-left: 100px;
    }
  }
  .foot-btn {
    padding: 30px;
    text-align: center;
    .el-button {
      width: 100px;
    }
  }
  .item3-add-pop {
    /deep/.el-dialog {
      position: absolute;
      top: 50%;
      left: 50%;
      z-index: 9;
      transform: translate(-50%, -50%);
      width: 60%;
      min-height: 50vh;
    }
    ul {
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 0 30px;
      li {
        margin-right: 30px;
        padding: 12px 16px 16px;
        cursor: pointer;
        border: 1px solid #D9D9D9;
        border-radius: 5px;
        &:last-child {
          margin-right: 0;
        }
        &.on {
          background: #FFFFFF;
          border: 2px solid #33B3FF;
          box-sizing: border-box;
          box-shadow: 0px 8px 24px rgba(51, 179, 255, 0.2);
          border-radius: 5px;
        }
        .title {
          display: block;
          margin-bottom: 8px;
          color: #000;
          font-size: 12px;
        }
        img {
          width: 100%;
        }
      }
    }
    .dialog-footer {
      text-align: center;
    }
  }
  .el-input,
  .el-select,
  .el-textarea {
    width: 460px !important;
    /deep/.el-input__count {
      bottom: -10px;
    }
  }
}
.btn_xtx_01{
    color: #33b3ff;
    cursor: pointer;
    text-decoration: underline;
}
.all-online2 {
    float: right;
    margin-right: 20px;
    color: #33b3ff;
    margin-top: 15px;
}
</style>

